import * as React from 'react';
import { HTMLAttributes } from 'react';
import * as cs from 'classnames';
import { AssetProps } from './Asset';
import './Image.css';

export enum Fit {
    Pad = 'pad',
    Fill = 'fill',
    Scale = 'scale',
    Crop = 'crop',
    Thumb = 'thumb',

}

export interface ImageProps extends AssetProps {
    width: number;
    height: number;
    defaultHeight: number;
    defaultWidth: number;
    fit: Fit;
}

const fittedUrl = (props: ImageProps) => {
    if (props.width > props.defaultWidth) {
        return `${props.url}?fit=${props.fit}&w=${props.defaultWidth}`;
    } else if (props.height > props.defaultHeight) {
        return `${props.url}?fit=${props.fit}&h=${props.defaultHeight}`;
    } else {
        return props.url;
    }
};

export const Image: React.FC<ImageProps & HTMLAttributes<HTMLDivElement>> =
    (props) => (
        <span className={cs('asset', 'asset-image', props.className)}>
            <img
                className="asset-image__image"
                alt={props.description}
                title={props.description}
                src={fittedUrl(props)}
            />
            <span className="asset-image__title">{props.title}</span>
        </span>
    );

Image.defaultProps = {
    defaultHeight: 700,
    defaultWidth: 1120,
    fit: Fit.Scale,
};


// WEBPACK FOOTER //
// ./src/asset/Image.tsx